import { render } from "./MetaTag.vue?vue&type=template&id=42108d75"
import script from "./MetaTag.vue?vue&type=script&lang=js"
export * from "./MetaTag.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rigun/MyData/project/masehi-kudus/sch-fe-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__